// ** Navigation imports
// import apps from './apps';
import all from './all';

// ** Merge & Export
export default [...all];
